import { render, staticRenderFns } from "./ProductOrderCofaDocumentPopUp.vue?vue&type=template&id=4c77e902&scoped=true&"
import script from "./ProductOrderCofaDocumentPopUp.vue?vue&type=script&lang=js&"
export * from "./ProductOrderCofaDocumentPopUp.vue?vue&type=script&lang=js&"
import style0 from "./ProductOrderCofaDocumentPopUp.vue?vue&type=style&index=0&id=4c77e902&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c77e902",
  null
  
)

export default component.exports